  import React, { useState, useEffect } from 'react';
  import {
    Box,
    Typography,
    Grid,
    MenuItem,
  } from '@mui/material';
  import { useDispatch, useSelector } from 'react-redux';
  import { toast } from 'react-toastify';
  import { GetAllStates } from '../../screen/auth/action/util_actions';
  import { getLocationAndPincodeAction, GetAllCityOfState } from '../../v2/Onboarding/auth/action';
  import CustomCheckbox from '../../v2/MUI_custom_component/Checkbox';
  import { TextField, CustomSelect } from '../../v2/MUI_custom_component';

  const ShippingAddress = ({
    buyer = {},
    setBuyer = () => {},
    influencerTabSelected = false,
    title = 'Shipping Address',
    checkboxLabel = 'Same As Billing Address',
    showCheckbox = true,
    sx = {},
  }) => {
    const dispatch = useDispatch();
    const { sameAsConsignee, } = useSelector((state) => {
      return {
        sameAsConsignee: state.dpReducer?.sameAsConsignee,
      };
    });
    const [localSameAsConsignee, setLocalSameAsConsignee] = useState(sameAsConsignee);
    const [states, setStates] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [allPincodes, setAllPincodes] = useState([]);
    const [allCities, setAllCities] = useState([]);
    const [firstSelection, setFirstSelection] = useState(null);
    const getlocationPincode = async (
      districtId,
      locationId = null,
      PincodeId = null,
    ) => {
      if (PincodeId && buyer.delivery_location_id) return;
      if (locationId && buyer.delivery_company_pincode) return;
      const { data, error } = await getLocationAndPincodeAction(districtId, {
        location_id: locationId,
        pincode_id: PincodeId,
      });
      if (!error) {
        if (locationId && !buyer.delivery_company_pincode) {
          setAllPincodes(
            data.pincode_list.map((pincode) => ({
              label: pincode.pincode_name,
              value: pincode.pincode_id,
            })),
          );
        } else if (PincodeId && !buyer.delivery_location_id) {
          setAllCities(
            data.location_list.map((city) => ({
              label: city.location_name,
              value: city.location_id,
            })),
          );
        } else if (!locationId && !PincodeId) {
          setAllPincodes(
            data.pincode_list.map((pincode) => ({
              label: pincode.pincode_name,
              value: pincode.pincode_id,
            })),
          );
          setAllCities(
            data.location_list.map((city) => ({
              label: city.location_name,
              value: city.location_id,
            })),
          );
        }
      }
    };
    const getStates = async () => {
      const { data, error, message } = await GetAllStates();

      if (!error) {
        setStates(
          data.map((state) => ({
            label: state.state_name,
            value: state.id,
          })),
        );
      } else {
        return toast.error(message);
      }
    };
    const getDistricts = async (stateId) => {
      setDistricts([]);
      const { data, error, message } = await GetAllCityOfState(stateId);
      if (!error) {
        setDistricts(
          data.map((district) => ({
            label: district.district_name,
            value: district.id,
          })),
        );
      } else return toast.error(message);
    };
    useEffect(() => {
      const stateId = localSameAsConsignee ? buyer.state_id : buyer.delivery_state_id;
      if (stateId) getDistricts(stateId);
    }, [buyer.state_id, buyer.delivery_state_id, localSameAsConsignee]);

    useEffect(() => {
      getStates();
    }, []);

    // useEffect(() => {
    //   if (!localSameAsConsignee && setBuyer) {
    //     setBuyer((prev) => ({
    //       ...prev,
    //       delivery_state_id: null,
    //       delivery_Address_line1: '',
    //       delivery_Address_line2: '',
    //       delivery_Address_line3: '',
    //       delivery_location_id: null,
    //       delivery_pricing_geography_id: null,
    //       delivery_district_id: null,
    //       delivery_company_pincode: null,
    //     }));
    //   }
    // }, []);

    useEffect(() => {
      if (buyer?.delivery_district_id) {
        getlocationPincode(buyer.delivery_district_id);
      }
    }, [buyer.delivery_district_id]);

    useEffect(() => {
      if (buyer.delivery_company_pincode) {
        getlocationPincode(
          buyer.delivery_district_id,
          null,
          buyer.delivery_company_pincode,
        );
      }
    }, [buyer.delivery_company_pincode]);

    useEffect(() => {
      if (buyer.delivery_location_id) {
        getlocationPincode(
          buyer.delivery_district_id,
          buyer.delivery_location_id,
          null,
        );
      }
    }, [buyer.delivery_location_id]);

    const handleSameAddressChange = () => {
      const newCheckedState = !localSameAsConsignee;
      setLocalSameAsConsignee(newCheckedState);
      
      if (newCheckedState) {
        setBuyer((prev) => ({
          ...prev,
          delivery_Address_line1: buyer?.company_address1 || '',
          delivery_Address_line2: buyer?.company_address2 || '',
          // delivery_Address_line3: buyer?.company_address3 || '',
          delivery_pricing_geography_id: buyer?.pricing_geography_id || null,
          delivery_state_id: buyer?.state_id || null,
          delivery_state_name: buyer?.state_name || null,
          delivery_location_id: buyer?.location_id || null,
          delivery_location_name: buyer?.location_name || null,
          delivery_district_id: buyer?.district_id || null,
          delivery_district_name: buyer?.district_name || null,
          delivery_company_pincode: buyer?.company_pincode || null,
        }));
      } else {
        setBuyer((prev) => ({
          ...prev,
          delivery_state_id: null,
          delivery_Address_line1: '',
          delivery_Address_line2: '',
          // delivery_Address_line3: '',
          delivery_location_id: null,
          delivery_pricing_geography_id: null,
          delivery_district_id: null,
          delivery_company_pincode: null,
        }));
      }
      
      dispatch({
        type: 'SET_SAME_AS_CONSIGNEE',
        data: newCheckedState,
      });
    };

    

    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          ...sx
        }}
      >
          <Typography variant='h2'>
              {title}
          </Typography>
          {showCheckbox && (
              <CustomCheckbox
                  checked={localSameAsConsignee}
                  color='primary'
                  label={checkboxLabel}
                  onChange={handleSameAddressChange}
                  sx={{}}
              />
          )}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}> 
              <Box sx={{ display: 'flex',flexDirection: { xs: 'column', md: 'row'}, gap: 1 }}> 
                  <TextField
                      fullWidth
                      label='Address line 1*'
                      placeholder='Enter address line 1'
                      variant='outlined'
                      disabled={localSameAsConsignee}
                      value={buyer.delivery_Address_line1}
                      onChange={(e) =>
                          setBuyer((prev) => ({
                              ...prev,
                              delivery_Address_line1: e.target.value,
                          }))
                      }
                  />
                  <TextField
                      fullWidth
                      label='Address line 2*'
                      variant='outlined'
                      placeholder='Enter address line 2'
                      disabled={localSameAsConsignee}
                      value={buyer.delivery_Address_line2}
                      onChange={(e) =>
                          setBuyer((prev) => ({
                              ...prev,
                              delivery_Address_line2: e.target.value,
                          }))
                      }
                  />
                  
              </Box>
              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: "row" }, gap: 1 }}>
                  {/* <TextField
                        fullWidth
                        label='Address line 3'
                        variant='outlined'
                        placeholder='Enter address line 3'
                        disabled={localSameAsConsignee}
                        value={buyer.delivery_Address_line3}
                        onChange={(e) =>
                            setBuyer((prev) => ({
                                ...prev,
                                delivery_Address_line3: e.target.value,
                            }))
                        }
                    /> */}
                  <CustomSelect
                      fullWidth
                      label='State*'
                      placeholder='Select State'
                      disabled={localSameAsConsignee}
                      value={localSameAsConsignee ? (buyer.state_id || '') : (buyer.delivery_state_id || '')}
                      onChange={(e) => {
                      if (localSameAsConsignee) {
                          setBuyer((prev) => ({ ...prev, state_id: e.target.value }));
                      } else {
                          const found = states.find(
                              (d) => d.value === e.target.value,
                          );
                          setBuyer((prev) => ({ 
                              ...prev, 
                              delivery_state_id: e.target.value,
                              delivery_state_name: found?.label || null,
                              // Clear dependent fields when state changes
                              delivery_district_id: null,
                              delivery_district_name: null,
                              delivery_location_id: null,
                              delivery_location_name: null,
                              delivery_pricing_geography_id: null,
                              delivery_pricing_geography_name: null,
                              delivery_company_pincode: null
                          }));
                          // Clear districts, cities, and pincodes arrays
                          setDistricts([]);
                          setAllCities([]);
                          setAllPincodes([]);
                      }
                      }}
                  >
                      {states.map((state) => {
                      return <MenuItem key={state.value} value={state.value}>{state.label}</MenuItem>;
                      })}
                  </CustomSelect>
                  
              </Box>
              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: "row" }, gap: 1 }}>
                  <CustomSelect
                      fullWidth
                      label='District*'
                      placeholder='Select District'
                      disabled={localSameAsConsignee || !buyer.delivery_state_id}
                      value={buyer.delivery_district_id || ''}
                      onChange={(e) => {
                      const found = districts.find(
                          (d) => d.value === e.target.value,
                      );
                      setBuyer((prev) => ({
                          ...prev,
                          delivery_district_id: e.target.value,
                          delivery_district_name: found.label,
                          delivery_location_id: null,
                          delivery_location_name: null,
                          delivery_pricing_geography_id: null,
                          delivery_pricing_geography_name: null,
                          delivery_company_pincode: null,
                      }));
                      // Clear cities and pincodes arrays when district changes
                      setAllCities([]);
                      setAllPincodes([]);
                      setFirstSelection(null);
                      }}
                  >
                      {districts.map((district) => {
                      return (
                          <MenuItem key={district.value} value={district.value}>{district.label}</MenuItem>
                      );
                      })}
                  </CustomSelect>
                  <CustomSelect
                      fullWidth
                      label='City*'
                      placeholder='Select City'
                      disabled={localSameAsConsignee || !buyer.delivery_state_id || !buyer.delivery_district_id}
                      value={buyer?.delivery_location_id || ''}
                      onChange={(e) => {
                      const found = allCities.find(
                          (d) => d.value === e.target.value,
                      );
                      if (!firstSelection) setFirstSelection('city');
                      setBuyer((prev) => ({
                          ...prev,
                          delivery_location_id: e.target.value,
                          delivery_location_name: found.label,
                          ...(firstSelection === 'city'
                          ? { delivery_company_pincode: null }
                          : {}),
                      }));
                      }}
                  >
                      {allCities.map((location) => {
                          return (
                              <MenuItem key={location.value} value={location.value}>{location.label}</MenuItem>
                          );
                      })}
                  </CustomSelect>
                 
              </Box>
              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: "row" }, gap: 1 }}>
                <CustomSelect
                   width={'70%'}
                  label='Pincode*'
                  placeholder='Select Pincode'
                  disabled={localSameAsConsignee || !buyer.delivery_state_id || !buyer.delivery_district_id}
                  value={buyer.delivery_company_pincode || ''}
                  onChange={(e) => {
                  if (!firstSelection) setFirstSelection('pincode');
                  setBuyer((prev) => ({
                      ...prev,
                      delivery_company_pincode: e.target.value,
                      ...(firstSelection === 'pincode'
                      ? {
                          delivery_location_id: null,
                          delivery_location_name: '',
                          }
                      : {}),
                  }));
                  }}
                >
                  {allPincodes.map((pincode) => {
                      return (
                          <MenuItem key={pincode.value} value={pincode.value}>{pincode.label}</MenuItem>
                      );
                    })}
                </CustomSelect>
              </Box>
          </Box>
      </Box>
    );
  };

  export default ShippingAddress;